import { render, staticRenderFns } from "./QuoteChangelog.vue?vue&type=template&id=2b03ab28&scoped=true&"
import script from "./QuoteChangelog.vue?vue&type=script&lang=js&"
export * from "./QuoteChangelog.vue?vue&type=script&lang=js&"
import style0 from "./QuoteChangelog.vue?vue&type=style&index=0&id=2b03ab28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03ab28",
  null
  
)

export default component.exports